/* eslint-disable no-return-assign */
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

import CmsContext from '../../../context/CmsContext';

function CitizenIdModal({ profile }) {
  const cmsContext = useContext(CmsContext)
  const setModal = useContext(ModalContext);

  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    // showTransaction(id);
  };

  const token = get('token') || '';

  const authProfile = getJson('profile') || {};

  const src = `${process.env.REACT_APP_WS}${c.CITIZEN_ID_URI_GENERATE.replace(
    '{id}',
    _.get(profile, 'id')
  )}?bearer_token=${token}&email=${_.get(
    authProfile,
    'email'
  )}`;

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title={`${_.get(CMS_VARIABLES, 'CITIZEN_ID')}`}
                  src={src}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CitizenIdModal.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  // showTransaction: PropTypes.instanceOf(Function).isRequired,
  // id: PropTypes.instanceOf(String).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CitizenIdModal);
